module.exports = __webpack_public_path__ + "media/brands/arrinera-03562cfb.png";